import React from 'react';
import JavascriptJsonIntro from './JavascriptJsonIntro.jsx';
import JavascriptJsonSyntax from './JavascriptJsonSyntax.jsx';
import JavascriptJsonVsXml from './JavascriptJsonVsXml.jsx';
import JavascriptJsonDataTypes from './JavascriptJsonDataTypes.jsx';
import JavascriptJsonParse from './JavascriptJsonParse.jsx';
import JavascriptJsonStringify from './JavascriptJsonStringify.jsx';
import JavascriptJsonObjects from './JavascriptJsonObjects.jsx';
import JavascriptJsonArrays from './JavascriptJsonArrays.jsx';
import JavascriptJsonServer from './JavascriptJsonServer.jsx';
import JavascriptJsonPhp from './JavascriptJsonPhp.jsx';
import JavascriptJsonHtml from './JavascriptJsonHtml.jsx';
import JavascriptJsonJsonp from './JavascriptJsonJsonp.jsx';

export default function JsJson() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS JSON</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/json/intro' className='underline'>JSON Intro</a></li>
<li><a href='/javascript/json/syntax' className='underline'>JSON Syntax</a></li>
<li><a href='/javascript/json/vs-xml' className='underline'>JSON vs XML</a></li>
<li><a href='/javascript/json/data-types' className='underline'>JSON Data Types</a></li>
<li><a href='/javascript/json/parse' className='underline'>JSON Parse</a></li>
<li><a href='/javascript/json/stringify' className='underline'>JSON Stringify</a></li>
<li><a href='/javascript/json/objects' className='underline'>JSON Objects</a></li>
<li><a href='/javascript/json/arrays' className='underline'>JSON Arrays</a></li>
<li><a href='/javascript/json/server' className='underline'>JSON Server</a></li>
<li><a href='/javascript/json/php' className='underline'>JSON PHP</a></li>
<li><a href='/javascript/json/html' className='underline'>JSON HTML</a></li>
<li><a href='/javascript/json/jsonp' className='underline'>JSON JSONP</a></li>
      </ul>
    </div>
  );
}
